export const dataChart = {
  labels: ['Pending', 'Open', 'Approved', 'Declined'],
  datasets: [
    {
      data: [10, 0, 20, 0],
      backgroundColor: [
        'rgb(249, 171, 0)',
        'rgb(64, 150, 255)',
        'rgb(29, 182, 120)',
        'rgb(245, 34, 45)',
      ],
      hoverOffset: 4,
    },
  ],
};

export const noDataChart = {
  labels: ['No Data'],
  datasets: [
    {
      data: [100],
      backgroundColor: ['rgba(0, 10, 41, 0.08)'],
      hoverOffset: 4,
    },
  ],
};

export const options = {
  plugins: {
    legend: {
      display: false,
    },
  },
};
